import * as React from 'react';
import { Container } from 'reactstrap';
import { Route, Switch } from 'react-router-dom';
import Layout from './components/Layout';
import Footer from './components/Footer';
import Landing from './components/landing/Landing';
import SplashScreen from './components/splashScreen/SplashScreen';
import LoadingOverlay from './components/basic/LoadingOverlay';
import PromiseErrorBoundary from './components/errorHandling/PromiseErrorBoundary';
import * as Roles from 'constants/Roles';

import ConversionListPage from './components/conversion/List';
import ConversionEditPage from './components/conversion/Edit';
import ConversionTabsPage from './components/conversion/Tabs';
import ReportViewPage from 'components/conversion/reports/Report';
import MappingPage from './components/conversion/mapping/Mapping';
import EpicSplitByBusinessUnitList from './components/split/epic/ByBusinessUnitList';
import EpicSplitByBusinessUnitCreate from './components/split/epic/ByBusinessUnitCreate';
import EpicSplitByBusinessUnitDetail from './components/split/epic/ByBusinessUnitDetail';

import AMS360SetupsList from './components/ndt/epic/AMS360SetupsList';
import AMS360SetupsCreate from './components/ndt/epic/AMS360SetupsCreate';
import AMS360SetupsDetail from './components/ndt/epic/AMS360SetupsDetail';

import ArchivedReportsPage from './pages/ArchivedReports';
import ArchivedConversionReportsPage from './pages/ArchivedReports/ReportsIndex';
import ArchivedConversionReportDownloadPage from './pages/ArchivedReports/ReportDownload';

import UserListPage from './components/user/List'
import UserEditPage from './components/user/Edit'

import ClientListPage from './components/client/List';
import ClientPage from './components/client/Edit';
import { SecureRoute } from './components/basic/Authentication';
import UIControllerTabs from './components/basic/uicontroller/UIControllerTabs';
import ADMPage from './components/conversion/mapping/ADMPage';

import { authentication } from './services/Authentication'

import './custom.css';
import './fonts.css';

export default class App extends React.PureComponent<{}>{

    constructor(props: Readonly<{}>) {
        super(props);
        authentication.refreshToken();
    }

    public render() {
        if (!sessionStorage['splashShown']) {
            setTimeout(() => {
                sessionStorage['splashShown'] = true
                this.forceUpdate()
            }, 3000)
            return <SplashScreen />
        }
        else {
            return (
                <PromiseErrorBoundary>
                    <Layout>
                        <Route exact path='/' component={Landing} />

                        <SecureRoute authenticated exact path='/conversion' component={ConversionListPage} />
                        <Switch>
                            <SecureRoute authenticated path='/conversion/new/mini'
                                render={props =>
                                    // TODO: bring it to a separate component.
                                    <Container>
                                        <ConversionEditPage {...props} isEditing={false} renderMode={'Mini'} />
                                    </Container>
                                } />
                            <SecureRoute authenticated path='/conversion/new/normal'
                                render={props =>
                                    // TODO: bring it to a separate component.
                                    <Container>
                                        <ConversionEditPage {...props} isEditing={false} renderMode={'Normal'} />
                                    </Container>
                                } />
                            <SecureRoute authenticated exact path='/conversion/:conversionId/:tabId' component={ConversionTabsPage} />
                            <SecureRoute authenticated path='/conversion/:conversionId/mapping' component={MappingPage} />
                            <SecureRoute authenticated path='/conversion/:conversionId/reports/:reportId' component={ReportViewPage} />
                        </Switch>

                        <SecureRoute roles={[
                            Roles.vertaforeInternalRoleId,
                            Roles.administrationRoleId,
                            Roles.developerAdministrationRoleId,
                            Roles.customerAdministratorRoleId
                        ]} exact path='/user' component={UserListPage} />
                        <Switch>
                            <SecureRoute roles={[
                                Roles.vertaforeInternalRoleId,
                                Roles.administrationRoleId,
                                Roles.developerAdministrationRoleId,
                                Roles.customerAdministratorRoleId,
                            ]} path='/user/new' component={UserEditPage} />
                            <SecureRoute roles={[
                                Roles.vertaforeInternalRoleId,
                                Roles.administrationRoleId,
                                Roles.developerAdministrationRoleId,
                                Roles.customerAdministratorRoleId,
                                Roles.customerUserRoleId
                            ]} exact path='/user/:userId' render={(props) => <UserEditPage {...props} isEditing={true} />} />
                        </Switch>

                        <SecureRoute roles={[Roles.developerAdministrationRoleId, Roles.administrationRoleId, Roles.vertaforeInternalRoleId]} exact path='/client' component={ClientListPage} />
                        <SecureRoute roles={[Roles.developerAdministrationRoleId]} exact path='/uicontroller' component={UIControllerTabs} />
                        <SecureRoute roles={[Roles.developerAdministrationRoleId]} exact path='/:conversionId/admpage' component={ADMPage} />
                        <SecureRoute roles={[
                            Roles.vertaforeInternalRoleId,
                            Roles.administrationRoleId,
                            Roles.developerAdministrationRoleId,
                        ]} exact path='/archived-reports' component={ArchivedReportsPage} />
                        <SecureRoute roles={[
                            Roles.vertaforeInternalRoleId,
                            Roles.administrationRoleId,
                            Roles.developerAdministrationRoleId,
                        ]} exact path='/archived-reports/reports' component={ArchivedConversionReportsPage} />
                        <SecureRoute roles={[
                            Roles.vertaforeInternalRoleId,
                            Roles.administrationRoleId,
                            Roles.developerAdministrationRoleId,
                        ]} exact path='/archived-reports/reports/:conversionId' component={ArchivedConversionReportDownloadPage} />
                        <Switch>
                            <SecureRoute roles={[Roles.developerAdministrationRoleId, Roles.administrationRoleId, Roles.vertaforeInternalRoleId]} path='/client/new' render={props => <ClientPage {...props} isEditing={false} />} />
                            <SecureRoute roles={[Roles.developerAdministrationRoleId, Roles.administrationRoleId, Roles.vertaforeInternalRoleId]} exact path='/client/:clientId' render={(props) => <ClientPage {...props} isEditing={true} />} />
                        </Switch>
                        <Switch>
                            <SecureRoute roles={[Roles.developerAdministrationRoleId, Roles.administrationRoleId, Roles.vertaforeInternalRoleId]} exact path='/tools/split/epic' component={EpicSplitByBusinessUnitList} />
                            <SecureRoute roles={[Roles.developerAdministrationRoleId, Roles.administrationRoleId, Roles.vertaforeInternalRoleId]} exact path='/tools/split/epic/new' component={EpicSplitByBusinessUnitCreate} />
                            <SecureRoute roles={[Roles.developerAdministrationRoleId, Roles.administrationRoleId, Roles.vertaforeInternalRoleId]} exact path='/tools/split/epic/:id' render={props => <EpicSplitByBusinessUnitDetail {...props} />} />
                        </Switch>
                        <Switch>
                            <SecureRoute roles={[Roles.developerAdministrationRoleId, Roles.administrationRoleId, Roles.vertaforeInternalRoleId]} exact path='/tools/ndt/epic' component={AMS360SetupsList} />
                            <SecureRoute roles={[Roles.developerAdministrationRoleId, Roles.administrationRoleId, Roles.vertaforeInternalRoleId]} exact path='/tools/ndt/epic/new' component={AMS360SetupsCreate} />
                            <SecureRoute roles={[Roles.developerAdministrationRoleId, Roles.administrationRoleId, Roles.vertaforeInternalRoleId]} exact path='/tools/ndt/epic/:id' render={props => <AMS360SetupsDetail {...props} />} />
                        </Switch>
                    </Layout>
                    <Footer />
                    <LoadingOverlay />
                </PromiseErrorBoundary>
            )
        }
    }
}
